import { render } from "./MyGroups.vue?vue&type=template&id=6b5c0628&ts=true"
import script from "./MyGroups.vue?vue&type=script&lang=ts"
export * from "./MyGroups.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__